import React, {PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import { Col, Container, Row, Collapse} from 'reactstrap';
import propTypes from 'prop-types';
import styled from 'styled-components';

import IconUp from '../../../../images/up-arrow-key.png';
import IconDown from '../../../../images/expand-button.png';

export default class Footer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      disableDesc: true
    }
  }

  parsingHTML() {
    const { details } = this.props;
    const content = details === null || details === "" ? "Belum ada deskripsi" : details;
    const tampilan = {
      __html: `${content}`	
    };
    return <DescriptionContent className="product__description__inner" dangerouslySetInnerHTML={tampilan} />
  }

  onToggle = () => {
    this.setState({ disableDesc: !this.state.disableDesc })
  }

  render() {
    return (
      <div>
        {
          this.props.collapse==true?
            <WrapperDescription className="product__description">
              <Row >
                <Col className="product__description__item">
                  <Title onClick={this.onToggle}>Product Description</Title>
                  <WrapperIcon onClick={this.onToggle} className="icon__description">
                    <KickImage src={this.state.disableDesc ? IconDown : IconUp} style={{ width: '100%', height: '100%' }} />
                  </WrapperIcon>
                </Col>
              </Row>
              <Collapse isOpen={this.state.disableDesc}>
                { this.parsingHTML() }
              </Collapse>
            </WrapperDescription>
          :
          <NewWrapperDescription className="new__product__description">
            <Row>
              <Col>
                <CenterTitle>Description</CenterTitle>
                <div className="new__product__description content">
                  { this.parsingHTML() }
                </div>
              </Col>
            </Row>
          </NewWrapperDescription>
        }
      </div>
    )
  }
}

const NewWrapperDescription = styled.div`
  width: 100%;
  padding: 15px 0;
  ${'' /* margin: 15px 0px 15px 0px; */}
`;

const CenterTitle = styled.p`
  font-size: 13px;
  color: #4a4a4a;
  font-family: Century Gothic Bold;
  margin: 0 0 10px 0;
  text-align: center;
`;

const WrapperDescription = styled.div`
  width: 100%;
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
  padding: 15px 0;
  margin: 15px 0px 15px 0px;
`;

const WrapperIcon = styled.div`
  width: 15px;
  height: auto;
  cursor: pointer;
  display: table;
  position: absolute;
  top: 0;
  left: 335px;
`;

const Title = styled.p`
  font-size: 13px;
  color: #4a4a4a;
  font-family: Century Gothic Bold;
  margin: 0;
  // text-align: left;
  cursor: pointer;
  @media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
    // text-align: right;
  }
`;

const DescriptionContent = styled.div`
  color: #4a4a4a;
  font-size: 12px;
  margin: 0px;
  padding: 30px 0px 0px 0px;
  text-align: center;  
  line-height: 27px;
  ul {
    padding-left: 20px;
  }
  ol {
    padding-left: 20px;
  }
`;  

Footer.propTypes={
    box_condition:propTypes.string,
    sku:propTypes.string,
    colourWay:propTypes.string
}
Footer.defaultProps={
    box_condition:undefined,
    sku:'',
    colourWay:''
}